import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { provide } from '@lit/context';
import {
  LoadingContext,
  loadingStateContext,
} from '../../contexts/loading.context';
import { tagName } from '../../helpers/element.helper';

const tag = tagName('load-state');

@customElement(tag)
export class LoadStateComponent extends TmElement {
  private loadingElements = new Set<string>();

  private checkScheduled = false;

  @property({ type: Boolean, reflect: true })
  public elementsLoading = true;

  @provide({ context: loadingStateContext })
  imageLoadingProvider: LoadingContext = {
    registerElement: (id: string) => {
      this.loadingElements.add(id);
      this.#checkLoadingState();
    },
    markElementLoaded: (id: string) => {
      this.loadingElements.delete(id);
      this.#checkLoadingState();
    },
    unregisterElement: (id: string) => {
      this.loadingElements.delete(id);
      this.#checkLoadingState();
    },
  };

  override firstUpdated() {
    this.#checkLoadingState();
  }

  async #checkLoadingState() {
    if (this.checkScheduled) {
      return;
    }

    this.checkScheduled = true;

    await this.updateComplete;

    requestAnimationFrame(() => {
      this.elementsLoading = this.loadingElements.size > 0;
      this.checkScheduled = false;
    });
  }

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-load-state': LoadStateComponent;
  }
}
